






import Vue from 'vue';
import { EArrowDirection } from '../../../common/enums/index.enum';
import ArrowIcon from '../../icons/ArrowIcon.vue';

export default Vue.extend({
  name: `Arrow`,
  components: { ArrowIcon },
  computed: {
    arrowClass(): string {
      switch(this.direction) {
        case EArrowDirection.LEFT:
          return `icon--left`;
        case EArrowDirection.DOWN:
          return `icon--down`;
        case EArrowDirection.UP:
          return `icon--up`;
        default:
          return ``;
      }
    },
  },
  props: {
    direction: {
      default: EArrowDirection.RIGHT,
      validator: val => Object.values(EArrowDirection).includes(val),
    },
  },
});
